import * as Yup from 'yup';

const createOrganizationSchema = (t: (key: string) => string) =>
  Yup.object().shape({
    name: Yup.string().required(t('signup_page.errors.required'))
  });

export default createOrganizationSchema;
